/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const Hand0Icon = ({ width = 24, height = 24, hidden = false, title = 'Hand0' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M28.239 19.456c-.552-.312-1.139-2.848-3.378-2.848a1.307 1.307 0 0 1-.6-.072c-.139-.089-.5-2.593-2.949-2.593a7.55 7.55 0 0 1-1.664-.12 3.3 3.3 0 0 0-2.816-1.859c-.232 0-1.388.261-1.423.261-1.26 0-1.664-1.25-3.627-.788-2.222.523-2.307 3.2-2.307 4.622 0 .671-2.114 2.966-2.114 2.966a5.613 5.613 0 0 0-.553 5.18c1.042 2.639 3.466 10.462 11.68 10.462 4.733 0 8.245-1.81 9.494-4.747.848-2.458 1.557-5.152 1.821-6.34a3.712 3.712 0 0 0-1.564-4.124Z"
    />
  </svg>`;
};
